import { assertIsString } from '@wix/seo-common-core';
import { getPathPrefix } from '@wix/seo-site-data-resolver';
const INVALID_PATH_VALUES = ['undefined', 'null', ''];
function isValidPath(path) {
  return typeof path === 'string' && !INVALID_PATH_VALUES.includes(path.trim());
}
function extractActiveItemMetadata(results) {
  const isMainLanguageItem = item => {
    var _item$metadata;
    return ((_item$metadata = item.metadata) == null || (_item$metadata = _item$metadata.language) == null ? void 0 : _item$metadata.isMain) ?? true;
  };
  const isActiveItem = item => !item.inactive;
  const isProtectedItem = item => item.protected ?? false;
  return results.filter(item => isActiveItem(item) && isMainLanguageItem(item) && !isProtectedItem(item) && isValidPath(item.path)).map(_ref => {
    let {
      itemId,
      path,
      itemTypeIdentifier,
      sourceId,
      configId,
      name
    } = _ref;
    assertIsString(itemId);
    assertIsString(path);
    assertIsString(name);
    const pathPrefix = getPathPrefix(itemTypeIdentifier ?? '', sourceId ?? '', configId ?? '');
    return {
      id: itemId,
      path: pathPrefix.length > 0 ? pathPrefix + path : path,
      name
    };
  });
}
export { extractActiveItemMetadata };
//# sourceMappingURL=site-structure.utils.js.map